import React from "react";
import BubbleVisualizer from "./BubbleVisualizer3.js";
import BubbleTimer from "./BubbleTimer.js";
import TaskBubbleContainer from "./TaskBubbleContainer";
import UpgradePrompt from "./UpgradePrompt";
import { PLUS } from "../helpers/subscriptionTiers";

const TasksView = ({ subscriptionTier, onShowSubscriptionMenu }) => {
  return (
    <>
      <BubbleVisualizer />

      {subscriptionTier >= PLUS ? (
        <BubbleTimer />
      ) : (
        <UpgradePrompt onShowSubscriptionMenu={onShowSubscriptionMenu} />
      )}

      <TaskBubbleContainer />
    </>
  );
};

export default TasksView;
